<div *ngIf="privilegesView==='AccessDenied'||id==='lock'||id===''" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div  class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>

<div *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" class="outside-container mt-4">
  <div class="box-container ">
      <div class="container">
          <div class="title ">

            <div class="row">
              <div *ngIf="!showBackbutton" class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
              <div *ngIf="showBackbutton" class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backScreenClick()" style="padding-left:20px;">⬅️</div></div>  

             <div class="col-md-7 d-flex justify-content-center">Commercials</div>
             <div class=" col-md-3 row ">
               <div class="d-flex justify-content-end">
                <button *ngIf="!screenShow&&showAirCommercial" class="btn btn-outline-primary btn-sm " (click)="OnClickAddPlan()"><img src="assets/images/Add_24.png">  New Plan</button>
                <button *ngIf="showAirCommercial&&screenShow" class="btn btn-outline-primary btn-sm " (click)="OnClickAddAir()"><img src="assets/images/Add_24.png"></button>
                <button *ngIf="!screenShow&&showHotelCommercial" class="btn btn-outline-primary btn-sm " (click)="OnClickAddHotel()"><img src="assets/images/Add_24.png"></button>
                <button *ngIf="!screenShow&&showInsuranceCommercial" class="btn btn-outline-primary btn-sm " (click)="OnClickAddInsurance()"><img src="assets/images/Add_24.png"></button>


             </div>
              </div>
            </div>
          
          </div> 
          </div>
          </div>
        </div>
        <div *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" class="outside-container ">
          <div class="box-container ">
              <div class="container ">
                <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
               
               
                  <div *ngIf="screenShow" class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                    <div class="col-md-12 ">
                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickAirCommercial()"  [ngClass]="{'activity' :showAirCommercial}">
                      Air Commercials</span></span>
                      

                  </div>
                    
                  </div>
                  <div *ngIf="!screenShow" class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                    <div class="col-md-12 ">
                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickAirCommercial()"     [ngClass]="{'activity' :showAirCommercial}">
                      Commercial Plans</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickHotelCommercial()"  [ngClass]="{'activity' :showHotelCommercial}"  >
                        Hotel Commercials
                    </span></span>
                    <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickInsuranceCommercial()"  [ngClass]="{'activity' :showInsuranceCommercial}"  >
                      Insurance Commercials
                  </span></span>
                  </div>
                    
                  </div>

                 <div class="col-md-10" style="height:70vh; overflow-y: auto;">


                  <div *ngIf="!screenShow&&showAirCommercial" class="col-md-12 card" style="min-height: 100%;" >

                    <div class=" row mt-3 " style="padding: 10px;">
                     
                      
                      <div class="col-md-12 " >
                       
                        <table mat-table [dataSource]="plansData" multiTemplateDataRows style="background-color: transparent;">
                       
                        <!-- <ng-container matColumnDef="expand">
                          <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                          <td mat-cell *matCellDef="let element">
                          <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                            <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
                            <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
                          </button>
                          </td>
                          </ng-container> -->
                         <ng-container matColumnDef="data1">
                           <th mat-header-cell *matHeaderCellDef>Name</th>
                           <td mat-cell *matCellDef="let element" > {{element?.name}} </td>
                         </ng-container>

                        <ng-container matColumnDef="data2">
                         <th mat-header-cell *matHeaderCellDef> Status </th>
                         <td mat-cell *matCellDef="let element" > 
                          <span *ngIf="element?.status==='A'">Enabled</span>
                          <span *ngIf="element?.status==='I'">Disabled</span>

                        </td>
                        </ng-container>
                        <ng-container matColumnDef="data3">
                          <th mat-header-cell *matHeaderCellDef> Actions </th>
                          <td mat-cell *matCellDef="let element" style="padding: 4px;" >    
                             <button   mat-button color="primary" (click)="PlanRowClick(element)">View Plan Commercials</button>
                             <!-- <button  *ngIf="element.default!=true && id" mat-button color="primary" (click)="PlanRowClick(element)">View Plan Commercials</button> -->

                          </td>
                         </ng-container> 
                         
                       
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsExistingDisplay.length">
                        <!-- <div class="example-element-detail row"
                         [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                         <div class=" card mt-2 mb-2 pb-2 pt-2 shadow">
                          <div class="col-md-12 d-flex justify-content-start mt-2">
                         <div class="col-md-6 row">
                         <span class="col-md-6 bold">State</span>
                         <span class="col-md-6">{{element?.state||"-"}}</span>
                         </div>
                         </div>
                         <div class="col-md-12 d-flex justify-content-start mt-2">
                           <div class="col-md-6 row">
                           <span class="col-md-6 bold">GST Number</span>
                           <span class="col-md-6">{{element?.entityGST||"-"}}</span>
                           </div>
                           </div>
                           <div class="col-md-12 d-flex justify-content-start mt-2">
                             <div class="col-md-6  row">
                             <span class="col-md-6 bold">GST Email</span>
                             <span class="col-md-6">{{element?.email||"-"}}</span>
                             </div>
                             </div>
                             <div class="col-md-12 d-flex justify-content-start mt-2">
                              <div class="col-md-6  row">
                              <span class="col-md-6 bold">Gst Name</span>
                              <span class="col-md-6">{{element?.gstName||"-"}}</span>
                              </div>
                              </div>
                              <div class="col-md-12 d-flex justify-content-start mt-2">
                                  <div class="col-md-6  row">
                                  <span class="col-md-6 bold">GST Address</span>
                                  <span class="col-md-6">{{element?.address||"-"}}</span>
                                  </div>
                                  </div>
                                  <div class="col-md-12 d-flex justify-content-start mt-2">
                                      <div class="col-md-6  row">
                                      <span class="col-md-6 bold">GST Phone</span>
                                      <span class="col-md-6">{{element?.phone||"-"}}</span>
                                      </div>
                                      </div>
                                      <div class="col-md-12 d-flex justify-content-start mt-2">
                                          <div class="col-md-6  row">
                                          <span class="col-md-6 bold">GST Accounts Code</span>
                                          <span class="col-md-6">{{element?.gstAccountCode||"-"}}</span>
                                          </div>
                                          </div>
                                          <div class="col-md-12 d-flex justify-content-start mt-2">
                                              <div class="col-md-6  row">
                                              <span class="col-md-6 bold">GST Type</span>
                                              <span class="col-md-6">{{element?.gstType||"-"}}</span>
                                              </div>
                                              </div>
                           </div>
                        </div> -->
                        </td>
                        </ng-container>
                        
                        <tr mat-header-row *matHeaderRowDef="columnsExistingDisplay"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsExistingDisplay;"
                        class="example-element-row">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                        <tr class="mat-row" *matNoDataRow>
                        <td  class="mat-cell" colspan="4">There is no data in this table</td>
                        </tr>
                        </table>
                        
                        
                        </div>
                        
                    
                  
                  </div> 
                    </div>

                    <div  *ngIf="showHotelCommercial ">
                      <app-hotel-commercials ></app-hotel-commercials>
  
                      </div>
                      <div  *ngIf="showInsuranceCommercial ">
                        <app-insurance-commercials ></app-insurance-commercials>
    
                        </div>
             <div *ngIf="screenShow" class="card" style="min-height: 100%;"> 
              <div class="title" style="text-align: left;    background: linear-gradient(90deg, #D2E0F5 10%, white 20%, white 20%, white 20%, white 20%);
              " > <div class="col-md-5  row" style="padding-left:10px ; font-size: 20px;" >

                <div class="col-md-6" >Plan Name</div>
                <div class="col-md-6">{{PlanRowData?.name||"-"}}</div>

              </div></div>
               
                   <div *ngIf="showAirCommercial && screenShow" class="col-md-12 "  >

                    <div class=" row mt-3 " style="padding: 10px;">
                     
                      
                      <div class="col-md-12 " >
                       
                        <table mat-table
                        [dataSource]="airData" multiTemplateDataRows style="background-color: transparent;">
                       
                        <!-- <ng-container matColumnDef="expand">
                          <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                          <td mat-cell *matCellDef="let element">
                          <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                            <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
                            <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
                          </button>
                          </td>
                          </ng-container> -->
                         <ng-container matColumnDef="data1">
                           <th mat-header-cell *matHeaderCellDef>Carrier/Source/Supplier</th>
                           <td mat-cell *matCellDef="let element" > {{carrierDataConverter(element?.carrier)}} / {{sourceDataConverter(element?.source)}} / {{supplierDataConverter(element?.supplier)}} </td>
                         </ng-container>

                        <ng-container matColumnDef="data2">
                         <th mat-header-cell *matHeaderCellDef>  Priority </th>
                         <td mat-cell *matCellDef="let element" >  {{element?.priority}}
                        </td>
                        </ng-container>
                        <ng-container matColumnDef="data3">
                          <th mat-header-cell *matHeaderCellDef> TravelType  </th>
                          <td mat-cell *matCellDef="let element"> 
                            {{element?.travelType==='D'?('Domestic'):''}}
                             {{element?.travelType==='I'?('International'):''}}

                           </td>
                         </ng-container> 
                          <ng-container matColumnDef="data4">
                          <th mat-header-cell *matHeaderCellDef> Commercial Category </th>
                          <td mat-cell *matCellDef="let element"> {{element?.commercialType}} </td>
                         </ng-container>  
                         <ng-container matColumnDef="data5">
                          <th mat-header-cell *matHeaderCellDef> Commercial </th>
                          <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);"  (click)="rowdataClick(element)"> {{"View"}} </td>
                         </ng-container>
                       
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDataDisplay.length">
                        <!-- <div class="example-element-detail row"
                         [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                         <div class=" card mt-2 mb-2 pb-2 pt-2 shadow">
                          <div class="col-md-12 d-flex justify-content-start mt-2">
                         <div class="col-md-6 row">
                         <span class="col-md-6 bold">State</span>
                         <span class="col-md-6">{{element?.state||"-"}}</span>
                         </div>
                         </div>
                         <div class="col-md-12 d-flex justify-content-start mt-2">
                           <div class="col-md-6 row">
                           <span class="col-md-6 bold">GST Number</span>
                           <span class="col-md-6">{{element?.entityGST||"-"}}</span>
                           </div>
                           </div>
                           <div class="col-md-12 d-flex justify-content-start mt-2">
                             <div class="col-md-6  row">
                             <span class="col-md-6 bold">GST Email</span>
                             <span class="col-md-6">{{element?.email||"-"}}</span>
                             </div>
                             </div>
                             <div class="col-md-12 d-flex justify-content-start mt-2">
                              <div class="col-md-6  row">
                              <span class="col-md-6 bold">Gst Name</span>
                              <span class="col-md-6">{{element?.gstName||"-"}}</span>
                              </div>
                              </div>
                              <div class="col-md-12 d-flex justify-content-start mt-2">
                                  <div class="col-md-6  row">
                                  <span class="col-md-6 bold">GST Address</span>
                                  <span class="col-md-6">{{element?.address||"-"}}</span>
                                  </div>
                                  </div>
                                  <div class="col-md-12 d-flex justify-content-start mt-2">
                                      <div class="col-md-6  row">
                                      <span class="col-md-6 bold">GST Phone</span>
                                      <span class="col-md-6">{{element?.phone||"-"}}</span>
                                      </div>
                                      </div>
                                      <div class="col-md-12 d-flex justify-content-start mt-2">
                                          <div class="col-md-6  row">
                                          <span class="col-md-6 bold">GST Accounts Code</span>
                                          <span class="col-md-6">{{element?.gstAccountCode||"-"}}</span>
                                          </div>
                                          </div>
                                          <div class="col-md-12 d-flex justify-content-start mt-2">
                                              <div class="col-md-6  row">
                                              <span class="col-md-6 bold">GST Type</span>
                                              <span class="col-md-6">{{element?.gstType||"-"}}</span>
                                              </div>
                                              </div>
                           </div>
                        </div> -->
                        </td>
                        </ng-container>
                        
                        <tr mat-header-row *matHeaderRowDef="columnsDataDisplay"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsDataDisplay;"
                        class="example-element-row">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                        <tr class="mat-row" *matNoDataRow>
                        <td  class="mat-cell" colspan="4">There is no data in this table</td>
                        </tr>
                        </table>
                        
                        
                        </div>
                        
                    
                  
                  </div> 
                    </div>
                   
                  </div>

                   
                  </div>
                  </div>
              </div>

              <div class="modal " id="myMod"  [style.display]="showPopup ? 'block' : 'none'" >
                <div class="modal-dialog" >
                    <div class="modal-content " >
                        <div class="modal-header ">
      <Strong></Strong>


                          <table class="styled-Upper-table" style="margin: 0; padding: 0;">
                          
                            <tbody>
                              <!-- Iterate through dynamic data rows -->
                              <tr style="background-color: #f2f2f2; ">
                                <!-- Display structured data -->
                                <td class="name-type" style="text-align: left;padding: 4px;width: 16.66%;">Commercial For</td>
                                <td  class="" style="background-color: #ffffff; width: 16.66%;padding: 4px">
                                  <!-- Interpret the character and display accordingly -->
                                  <form [formGroup]="airRegFg" >  
                                    {{airRegFg.value.commercialType||''}}

                                    <mat-checkbox *ngIf="airRegFg.value.commercialType==='DISCOUNT'||airRegFg.value.commercialType==='COMMISSION'||airRegFg.value.commercialType==='MARKUP'"   class="custom-small-checkbox" color="primary" formControlName="isDefaultPlan">Is Default </mat-checkbox>
                          <!-- Add additional conditions for other types of data (blank fields, etc.) --></form>
                                </td>
                                <td class="name-type" style="text-align: left;padding: 4px;width: 16.66%;">Priority</td>
                                <td  class="" style="background-color: #ffffff; width: 16.66%;">
                                  <!-- Interpret the character and display accordingly -->
                                  <form [formGroup]="airRegFg" class="example-form" style="padding: 5px; ">  
                                    <mat-select formControlName="priority">

                                      <mat-option class="mat-primary" *ngFor="let item of numbers" [value]="item">{{item}}</mat-option>

                                    </mat-select>
                                  </form>                            <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                                <td class="name-type" style="text-align: left;padding: 4px;width: 16.66%;"
                                >Travel Type  </td>
                                <td  class="" style="background-color: #ffffff; width: 16.66%;">
                                  <!-- Interpret the character and display accordingly -->
                                 {{airRegFg.value.travelType==='D'?('Domestic'):''}} {{airRegFg.value.travelType==='I'?('International'):''}}

                          <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                                
                              </tr>
                              <tr style="background-color: #f2f2f2;">
                                <!-- Display structured data -->
                               
                                <td class="name-type" style="text-align: left;padding: 4px">Source </td>
                                <td  class="" style="background-color: #ffffff;">
                                  <!-- Interpret the character and display accordingly -->
                                  <form [formGroup]="airRegFg" class="example-form" style="padding: 5px;">  
                                    <mat-select   formControlName="source" style="color: white; font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
                                    outline:none;
                                    background-color: transparent;">
                                      <mat-option class="mat-primary" value="">DEFAULT</mat-option>     

                                      <mat-option class="mat-primary" *ngFor="let source of sourceCodeList" [value]="source.code">{{source.title}}</mat-option>

                                    </mat-select>
                                  </form>
                          <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                                <td class="name-type"style="text-align: left;padding: 4px" >Supplier</td>
                                <td  class="" style="background-color: #ffffff; ">
                                  <!-- Interpret the character and display accordingly -->
                                  <form [formGroup]="airRegFg" class="example-form" style="padding: 5px; ">  
                                    <mat-select formControlName="supplier">    
                                      <mat-option class="mat-primary" value="">DEFAULT</mat-option>     
                                       <mat-option class="mat-primary" *ngFor="let supplier of supplierList" [value]="supplier.code">{{supplier.name}}</mat-option>
                                  </mat-select> 
                                  </form>                           <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                                <td class="name-type" style="text-align: left;padding: 4px">Carrier</td>
                                <td class="" style="background-color: #ffffff; " >
                                  <!-- Interpret the character and display accordingly -->
                                  <form [formGroup]="airRegFg" class="example-form" style="padding: 5px; ">  
                                    <mat-select formControlName="carrier">
                                      <mat-option class="mat-primary" value="">DEFAULT</mat-option>     

                                    <mat-option class="mat-primary" *ngFor="let carrier of carrierList" [value]="carrier.airlineDesignatorCode">{{carrier.carrierName}}</mat-option>
                                  </mat-select>
                                      </form>                             <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                              </tr>
                              <tr style="background-color: #f2f2f2; ">
                                <!-- Display structured data -->
                                <td class="name-type" style="text-align: left;padding: 4px">Fare Type (: Separated)</td>
                                <td  class="" style="background-color: #ffffff; ">
                                  <!-- Interpret the character and display accordingly -->
                                  
                                  <form [formGroup]="airRegFg" class="example-form" style="padding: 5px; max-width:200px ;">  
                                    <mat-select matNativeControl  name="fareType" formControlName="fareType">
                                      <mat-option  class="mat-primary" value="">{{'-'}}</mat-option>
                                      <mat-option *ngFor="let type of fareTypeList" class="mat-primary" [value]="type.key">{{type?.value}}</mat-option>
                                     
                    
                                    </mat-select> 
                                    
                                    <!-- <input matInput type="text"  maxlength="35" formControlName="fareType" name="fareTypes" style="color: black; font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
                                    outline:none;
                                    background-color: transparent;"> -->
                                      
                                  </form>
                          <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                                <td class="name-type"  style="text-align: left;padding: 4px">RBD Class</td>
                                <td  class="" style="background-color: #ffffff; ">
                                  <!-- Interpret the character and display accordingly -->
                                  <form [formGroup]="airRegFg" class="example-form" style="padding: 5px; max-width:100px ;">  
                                    <input matInput type="text" maxlength="35" formControlName="rbdClass" name="rbdClasses" style="color: black; font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
                                    outline:none;
                                    background-color: transparent;">
                                      
                                  </form>
                          <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                                <td class="name-type" >{{"Cabin Class (: Separated)"}}</td>
                                <td  class="" style="background-color: #ffffff; ">
                                  <!-- Interpret the character and display accordingly -->
                                  <form [formGroup]="airRegFg" class="example-form" style="padding: 5px; max-width: 170px;">  
                                    <!-- <input matInput type="text" maxlength="35" formControlName="cabinClass" name="cabinClass" style="color: black; font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
                                    outline:none;
                                    background-color: transparent;"> -->
                                  <mat-select matNativeControl multiple name="cabinClass" formControlName="cabinClass">
                                    <mat-option  class="mat-primary" value="F">First</mat-option>
                                    <mat-option class="mat-primary" value="Y">Economy</mat-option>
                                    <mat-option class="mat-primary" value="W">Premium Economy</mat-option>
                                    <mat-option class="mat-primary" value="C">Business</mat-option>
                  
                                  </mat-select>         
                                  </form>
                          <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                </td>
                              </tr>
                              
                            </tbody>
                          </table>  
                          
                          <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                          </div>
                          <div class="modal-body ">
                               <div class="card shadow">    
                            <table  class="styled-table ">
                              <thead>
                                <tr >
                                  <!-- Dynamic headers based on tableHeaders array -->
                                  <th style="padding: 8px;  text-align: center;">Fixed Commercials  </th>
                                  <th *ngFor="let header of tableHeaders" style="padding: 8px;  text-align: center;" >{{header.type}} {{ header.values }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <!-- Iterate through dynamic data rows -->
                                <tr *ngFor="let row of tableData">
                                  <!-- Display structured data -->
                                  <td class="name-type" style="padding: 8px;">{{ row?.name }} {{ row?.type?("("+row?.type+")"):"" }}</td>
                                  <td *ngFor="let value of row.values ;let i=index" class="value-cell" >
                                    <!-- Interpret the character and display accordingly -->
                                    <input  [(ngModel)]="dataRequest[i][row?.json]"   (keypress)="onlyNumberKey($event)" style=" font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
                                    outline:none;max-width: 80px; margin:5px;
                                    background-color: transparent;" *ngIf="value === 'T'" type="text" />
                            
                                    <input [(ngModel)]="dataRequest[i][row?.json]" *ngIf="value === 'C'" style="margin: 5px; cursor: pointer;" class=" checkbox-container " type="checkbox" />
                            <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="card shadow mt-4">    

                            <table class="styled-tables shadow">
                              <thead>
                                <tr >
                                  <th class="shadow" style="padding: 8px; text-align: center;">Rate Commercials</th>
                                  <th class="shadow" style="padding: 8px; text-align: center;">Rate</th>
                                  <th class="shadow" style="padding: 8px; text-align: center;">Settings</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let row of rateComponents">
                                  <td class="name-type" style="padding: 8px;">{{ row?.label }}</td>
                                  <td class="name-type" style="padding: 8px;">
                                    <input 
                                      (keypress)="onlyNumberKey($event)"
                                      style="font-size: 15px; border-bottom: solid; border-left: none; border-right: none; border-top: none; outline:none; max-width: 80px; margin:5px; background-color: transparent;"
                                      type="text"
                                      [(ngModel)]="row.rate"
                                      (input)="checkMaxValue($event)"
                                    />
                                  </td>
                                  <td class="name-type" style="padding: 8px;">
                                    <div *ngFor="let tag of row.tags.split('#'); let i=index">
                                      <ng-container *ngIf="tag.includes(':c')">
                                        <input
                                          type="checkbox" style="cursor: pointer;"
                                          class="checkbox-container"
                                          [(ngModel)]="row.checkboxValues[tag.split(':')[0]]"
                                        />
                                      </ng-container>
                                      <ng-container *ngIf="tag.includes(':t')">
                                        <input
                                          type="text"
                                          style="font-size: 15px; border-bottom: solid; border-left: none; border-right: none; border-top: none; outline:none; margin:5px; background-color: transparent; min-width: 100px; max-width: 100px;"
                                          [(ngModel)]="row.textValues[tag.split(':')[0]]"
                                        />
                                      </ng-container>
                                      <label style="margin-left: 10px;">{{ tag.split(':')[0] }}</label>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
</div>
<!-- Your Angular component template -->
<!-- Your Angular component template -->



<!-- <table class="styled-tables ">
<thead>
  <tr >
    <th style="padding: 8px;  text-align: center;">Filter Type</th>
    <th style="padding: 8px;  text-align: center;">
      <div class="col-md-12 row"  >

      <div class="col-md-6 d-flex justify-content-center">Include</div>
      <div class="col-md-6 d-flex justify-content-center" >Exclude</div>

    </div></th>

  </tr>
</thead>
<tbody>
  <tr *ngFor="let row of fixComponents">
    <td class="name-type" style="padding: 8px;">{{ row?.label }}</td>
    
    <td class="name-type " style="padding: 8px;">
      <div class="col-md-12 row">
      <div *ngFor="let tag of row.tags.split('#');let i=index" class=" col-md-6" style="border-left: 1px solid #ddd;">
        <div *ngIf="tag.includes('I')" class="col-md-12 d-flex justify-content-center" >

        <ng-container >
        

          <input type="text"  style=" font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
          outline:none; margin:5px;
          background-color: transparent; min-width: 100px;  max-width: 100%;" />           

        </ng-container>
      </div>

        <div *ngIf="tag.includes('X')" class="col-md-12 d-flex justify-content-center" >

          <ng-container >
            <input type="text"  style=" font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
            outline:none; margin:5px;
            background-color: transparent; min-width: 100px;  max-width: 100%;" />
          
          </ng-container>
        </div>
      </div >
    </div>

      
        
    
    </td>


  </tr>
</tbody>
</table> -->
</div>
                            <div class="modal-footer">
                             
                              <button  class="btn btn-outline-success c-width-100px shadow " (click)="upDatePlan()"  >Save</button>
                              <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                         
                            </div>
                            
                          </div>
                          
                  </div>
              </div>

              <div class="modal " id="myMod"  [style.display]="planPopup ? 'block' : 'none'" >
                <div class="modal-dialog" >
                    <div class="modal-content" style="width:110%; margin: 10% 40% auto;" >
                        <div class="modal-header title">
                          Add Plan
                          <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                        </div>
                      <div class="modal-body">
                      

                        <form [formGroup]="plansRegFg" class=" row" >
                        
                                <mat-form-field class=" required col-md-12 form-group " appearance="outline">
                                  <mat-label>Name</mat-label>
                                  <input matInput  type="text" maxlength="30"  formControlName="name"  name="name" autocomplete="off"  >
                                </mat-form-field>
                              
                                <mat-form-field class="  col-md-12 form-group " appearance="outline" >
                                  <mat-label>Copy From</mat-label>
                                  <mat-select formControlName="templatePlan">

                                    <mat-option *ngFor="let item of plansData" [value]="item.planUid">{{item.name}}</mat-option>

                                  </mat-select>
                                    </mat-form-field>
                                <mat-form-field class="  col-md-12 form-group " appearance="outline" >
                                  <mat-label>Discription</mat-label>
                                  <textarea matInput  formControlName="description" type="text"  id="inputname" rows="1"  name="discription" autocomplete="off"  ></textarea>
                                    </mat-form-field>
                                                                           
                            </form>
                      
                       </div>

                            
                            <div class="modal-footer">
                              <button *ngIf="!showButton" class="btn btn-outline-success c-width-100px shadow " (click)="commercialData()" [disabled]="plansRegFg.invalid" >Save</button>
                              <button *ngIf="showButton" class="btn btn-outline-success c-width-100px shadow "  [disabled]="true" >Save</button>

                                  <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                             
                         
                            </div>
                            
                          </div>
                          </div>
                  </div>


                  <div class="modal " id="myMod"  [style.display]="AirPopup ? 'block' : 'none'" >
                    <div class="modal-dialog" >
                        <div class="modal-content" style="width:110%; margin: 10% 40% auto;" >
                            <div class="modal-header title">
                              Add Commercials
                                <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                          <div class="modal-body">
                          
  
                            <form [formGroup]="airRegFg" class=" row" >
                            
                                   
                                  
                                    <mat-form-field class="  col-md-6  " appearance="outline" >
                                      <mat-label >Travel Type</mat-label>
                                      <mat-select formControlName="travelType">
                                        <mat-option value="D">Domestic</mat-option>
                                        <mat-option value="I">International</mat-option>
                                      </mat-select>
                                     

                                        </mat-form-field>
                                   
                                        <mat-form-field class="  col-md-6  " appearance="outline" >
                                          <mat-label  >Source</mat-label>
                                          <mat-select formControlName="source">
                                            <mat-option value="">DEFAULT</mat-option>     

                                            <mat-option *ngFor="let source of sourceCodeList" [value]="source?.code">{{source?.title}}</mat-option>

                                          </mat-select>
                                            </mat-form-field>
                                            <mat-form-field class="  col-md-6  " appearance="outline" >
                                              <mat-label >Supplier</mat-label>
                                              <mat-select formControlName="supplier">    
                                                <mat-option value="">DEFAULT</mat-option>     
                                                 <mat-option *ngFor="let supplier of supplierList" [value]="supplier.code">{{supplier.name}}</mat-option>
                                            </mat-select>

                                                </mat-form-field>
                                                <mat-form-field class="  col-md-6  " appearance="outline" >
                                                  <mat-label style="padding-right:4px ;">Carrier</mat-label>
                                                  <mat-select formControlName="carrier">
                                                    <mat-option value="">DEFAULT</mat-option>     

                                                  <mat-option *ngFor="let carrier of carrierList" [value]="carrier.airlineDesignatorCode">{{carrier.carrierName}}</mat-option>
                                                </mat-select>
                                                    </mat-form-field>
                                                    <mat-form-field class="  col-md-6  " appearance="outline" >
                                                      <mat-label style="padding-right:4px ;">Fare Type </mat-label>
                                                      <mat-select matNativeControl  name="fareType" formControlName="fareType">
                                                        <mat-option  class="mat-primary" value="">{{'-'}}</mat-option>

                                                        <mat-option *ngFor="let type of fareTypeList" class="mat-primary" [value]="type.key">{{type?.value}}</mat-option>
                                                       
                                      
                                                      </mat-select> 
                                                     <!-- <input matInput type="text" maxlength="35" formControlName="fareType" name="fareType"> -->
                                                        </mat-form-field>
                                                        <mat-form-field class="  col-md-6  " appearance="outline" >
                                                          <mat-label style="padding-right:4px ;">RBD Class (: Separated)</mat-label>
                                                         <input matInput type="text" maxlength="35" formControlName="rbdClass"  name="rbdClass">
                                                            </mat-form-field>

                                                    <mat-form-field class="  col-md-6  " appearance="outline" >
                                                      <mat-label >Priority</mat-label>
                                                      <mat-select formControlName="priority">

                                                        <mat-option *ngFor="let item of numbers" [value]="item">{{item}}</mat-option>

                                                      </mat-select>
                                                        </mat-form-field> 
                                                        <mat-form-field class="  col-md-6  " appearance="outline" >
                                                          <mat-label >Commercial Type</mat-label>
                                                          <mat-select formControlName="commercialType">
                                                            <mat-option *ngFor="let item of commercialType" [value]="item">{{item}}</mat-option>

                                                          </mat-select>
                                                            </mat-form-field>   
                                                            <mat-form-field class="  col-md-6  " appearance="outline" >

                                                            <mat-label >Cabin Class (: Separated)</mat-label>
                                                            <!-- <input matInput type="text" maxlength="35" formControlName="cabinClass"  name="cabinClass"> -->
                                                            <mat-select matNativeControl multiple name="cabinClass" formControlName="cabinClass">
                                                              <mat-option  class="mat-primary" value="F">First</mat-option>
                                                              <mat-option class="mat-primary" value="Y">Economy</mat-option>
                                                              <mat-option class="mat-primary" value="W">Premium Economy</mat-option>
                                                              <mat-option class="mat-primary" value="C">Business</mat-option>
                                            
                                                            </mat-select>
                                                            <!-- <mat-select mul matNativeControl name="cabinClass" formControlName="cabinClass">
                                                              <mat-option value="F">First</mat-option>
                                                              <mat-option value="Y">Economy</mat-option>
                                                              <mat-option value="W">Premium Economy</mat-option>
                                                              <mat-option value="C">Business</mat-option>
                                            
                                                            </mat-select>     -->
                                                          </mat-form-field>  
                                                          <div *ngIf="airRegFg.value.commercialType==='DISCOUNT'||airRegFg.value.commercialType==='COMMISSION'||airRegFg.value.commercialType==='MARKUP'" class="col-md-6">
                                                            <mat-checkbox color="primary" formControlName="isDefaultPlan">Is Default </mat-checkbox>
                                                          </div>
                        
                                </form>
                          
                           </div>
  
                                
                                <div class="modal-footer">
                                  <button *ngIf="!showAirButton" class="btn btn-outline-success c-width-100px shadow " (click)="addAirCommercials()" [disabled]="airRegFg.invalid" >Save</button>
                                  <button *ngIf="showAirButton" class="btn btn-outline-success c-width-100px shadow "  [disabled]="true" >Save</button>
  
                                      <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                                 
                             
                                </div>
                                
                              </div>
                              </div>
                      </div>
              </div>